module.exports = __webpack_public_path__ + "static/capabilities-php-3-33f9f1382a972bf86c0cc9ff96171e2e.jpg";